import React, {useEffect, useState} from "react";
import styles from './AirportSelector.module.scss';
import FormikSearchSelector from "gui/components/formikSearchSelector/FormikSearchSelector";
import {components} from 'react-select';
import {allowOnlyEnglishAutoConvert, replaceArrayAllCaseInsensitive} from 'data/utils/shortcuts';
import {IAirport} from 'data/interfaces/products';
import {capitalize} from '@material-ui/core';

export interface IAirportSelectorProps {
  label: string;
  field?: any;
  queryAirport: (query) => Promise<any>;
  defaultValueQuery?: string;
  form?: any;
}

const NoOptionsMessage = props => {
  return (null);
};


const commonTexts = [
  'international',
  'intl',
  'airport',
  'airfield',
  'airline',
  'air base',
  'airbase',
];

const filteredAirportName = (name): string => {
  return replaceArrayAllCaseInsensitive(name, commonTexts);
};

const formatAirportName = (name, iata, city): string => {
  name = replaceArrayAllCaseInsensitive(name, [city, '-'], '').replace(/[-_]/g, " ").replace(/[ ]+/g, " ").replace(/[^A-Za-z ]+/gi, "").trim();
  return [capitalize(name || ''), `(${iata})`].join(" ");
};

const formatNameForComparison = name => name.toUpperCase().replace(/(?![IEUOA])[^A-Z]+/gi, "");

const compareCityToAirportName = (airportName, city) => formatNameForComparison(airportName) === formatNameForComparison(city);

const formatAirportLabel = ({name, city, country, iata}: IAirport) => {
//  console.log(1111,name);
  name = (filteredAirportName(name) || '').trim();
  if (!name) {
    return null;
  }
//  console.log(2222,name);
//  if (compareCityToAirportName(name, city)) {
//    return null;
//  }
  return [formatAirportName(name, iata, city), capitalize(city || ''), capitalize(country || '')].join(" ,");
};

const Option = ({children, ...restProps}) => {
  const airportName = formatAirportLabel(restProps.data.value);
  if (airportName) {
    return (
      <components.Option {...restProps}>
        {airportName}
      </components.Option>
    );
  }
  return null;
};


const MenuList = props => {
  return (
    <components.MenuList
      {...props}>
      {props.children}
      <p>
        חפש/י שם שדה תעופה , קוד של שדה תעופה, ארץ, או עיר באנגלית
      </p>

    </components.MenuList>
  )
};

const AirportSelector = (props: IAirportSelectorProps) => {
  const [isDefaultAlreadySet, setDefaultAlreadySet] = useState(false);
  useEffect(() => {
    if (!isDefaultAlreadySet && props.defaultValueQuery && !props.field.value) {
      props.queryAirport(props.defaultValueQuery)
        .then(result => {
          if (result.length > 0) {
            props.form.setFieldValue(props.field.name, result[0].value);
            setDefaultAlreadySet(true);
          }
        });
    }
  }, [props.defaultValueQuery, props.field.value, props.form.setFieldValue, isDefaultAlreadySet, setDefaultAlreadySet]);
  return (
    <FormikSearchSelector
      className={styles.airportsAutoCompleteSelector}
      options={props.field.value ? [{label: formatAirportLabel(props.field.value), value: props.field.value}] : []}
      promiseOptions={props.queryAirport}
      components={{MenuList, NoOptionsMessage, Option}}
      onInputChange={value => value ? undefined : allowOnlyEnglishAutoConvert(value).toLowerCase()}
      {...props}
      onChange={(airport: any) => {
        props.field.onChange({
          target: {
            name: props.field.name,
            value: airport || undefined,
          },
        });
      }}
      errorClassName={styles.errorContainer}
    />
  );
};

AirportSelector.defaultProps =
  {
    queryAirport: (query) => Promise.resolve(),
  };

export default AirportSelector;
